<template>
    <b-modal
        size="lg"
        v-model="modalShow"
        title="サービスモデル設定"
        @hidden="close">
        <div class="form-group mt-1 mb-0">
            <div class="form-check form-check-inline">
                <label
                    class="mb-0">
                    <input
                        type="checkbox"
                        v-model="isCustomMedicalCourses"
                        @change="changed()"
                        class="form-check-input">
                    {{ $locale.consultation_host }}科の表示設定をカスタマイズする
                </label>
            </div>
        </div>

        <div
            v-if="plan !== null"
            class="scrollWrapper mt-3">
            <div class="scroll">
                <div class="row">
                    <div class="col-12">
                        <div class="m-form__group form-group">
                            <div
                                class="row m-0 medicalCourseCheckboxes"
                                :class="{ 'is-invalid' : !!errors.medical_courses !== false }">
                                <div v-for="medicalCourse in medicalCourses"
                                        class="col col-sm-6 col-md-4 mb-1">
                                    <div class="form-check">
                                        <input
                                            v-model="selectedMedicalCourseIds"
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="medicalCourse.id"
                                            :id="`medical_course_${medicalCourse.id}`"
                                            :disabled="!isCustomMedicalCourses"
                                        >
                                        <label
                                            :for="`medical_course_${medicalCourse.id}`"
                                            class="form-check-label">
                                            {{ medicalCourse.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="invalid-feedback d-block mb-3"
                            v-if="errors.medical_courses">
                            {{ errors.medical_courses[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="plan !== null"
            class="form-group m-form__group">
            <label :class="{ 'text-muted' : !isDoctorPass }">渡航証明書のアップロード</label>
            <div>
                <div class="form-check form-check-inline">
                    <input
                        v-model="plan.is_upload_document"
                        :value="true"
                        :disabled="!isDoctorPass"
                        type="radio"
                        id="is_upload_document_true"
                        class="form-check-input">
                    <label
                        class="form-check-label"
                        for="is_upload_document_true">
                        ON
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input
                        v-model="plan.is_upload_document"
                        :value="false"
                        :disabled="!isDoctorPass"
                        type="radio"
                        id="is_upload_document_false"
                        class="form-check-input">
                    <label
                        class="form-check-label"
                        for="is_upload_document_false">
                        OFF
                    </label>
                </div>
            </div>
        </div>

        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <button
                class="btn btn-yokumiru-orange float-right"
                style="width:90px;"
                :disabled="inProgress"
                @click="handleOk">
                保存
            </button>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'AdminServiceModelSettingModal',

        data: function() {
            return {
                helper: YokumiruHelper,
                plan: null,
                inProgress: false,
                modalShow: false,
                medicalCourses: [], // 全ての相談科
                defaultMedicalCourses: [], // 表示設定された相談科
                selectedMedicalCourseIds: [],
                isCustomMedicalCourses: false,
                errors: {},
            }
        },

        computed: {
            isDoctorPass: function () {
                return this.helper.isDoctorPass(this.plan)
            },
        },

        created: function () {
            bus.$on('open-modal-admin-service-setting', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-service-setting')
        },

        methods: {
            /**
             * モーダル表示
             * @param {object} plan
             */
             open: function (plan) {
                this.plan = {...plan}

                this.isCustomMedicalCourses = this.plan.is_custom_medical_courses
                this.selectedMedicalCourseIds = []

                if (this.isCustomMedicalCourses) {
                    this.selectedMedicalCourseIds = this.plan.medical_courses.map((medicalCourse) => {
                        return medicalCourse.id
                    })
                }

                this.fetchMedicalCourses()
                this.errors = {}
                this.modalShow = true
            },
            /**
             * 保存ボタン押下時
             *
             * @param {object} e
             */
             handleOk: async function (e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    is_custom_medical_courses: this.isCustomMedicalCourses,
                    medical_course_ids: this.isCustomMedicalCourses ? this.selectedMedicalCourseIds : [],
                    is_upload_document: this.plan.is_upload_document,
                }

                const endpoint = constants.admin.plans.endpoint.base
                await axios.put(`${endpoint}/${this.plan.id}/settings`, params)
                    .then(() => {
                        bus.$emit('alert-success', 'サービスモデルを編集しました。')
                        bus.$emit('plan-edited')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                this.errors = response.data.errors
                                bus.$emit('alert-danger')
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    });

                this.inProgress = false
            },
            /**
             * モーダルを閉じる
             */
             close: function () {
                this.modalShow = false
            },

            /**
             * 相談科一覧取得
             */
             fetchMedicalCourses: function () {
                axios.get(`${constants.admin.medical_courses.endpoint.base}`)
                    .then(({data}) => {
                        this.medicalCourses = data

                        return axios.get(`${constants.admin.medical_courses.endpoint.base}?show=1`)
                    })
                    .then(({data}) => {
                        this.defaultMedicalCourses = data

                        if (!this.plan.is_custom_medical_courses) {
                            this.selectedMedicalCourseIds = this.defaultMedicalCourses.map((medicalCourse) => {
                                return medicalCourse.id
                            })
                        }
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.scrollWrapper {
    .scroll {
        height: 30%;
        overflow-x: hidden;
    }

    .medicalCourseCheckboxes {
        border: 1px solid;
        border-color: lightgray;
        border-radius: 4px;
        padding: 10px;
    }
}
</style>
